/**
 * Long-press shortcuts on the app icon (mobile M7): Which card?, Spends,
 * Sync now. Android app only.
 */

import { isNative } from "./index";

export type ShortcutId = "which" | "spends" | "sync";

const SHORTCUTS: { id: ShortcutId; title: string; description: string; icon: string }[] = [
  { id: "which", title: "Which card?", description: "Plan a purchase", icon: "ic_shortcut_which" },
  { id: "spends", title: "Spends", description: "Your transactions", icon: "ic_shortcut_spends" },
  { id: "sync", title: "Sync now", description: "Check the inbox", icon: "ic_shortcut_sync" },
];

/** Put MyDeck's three shortcuts on the launcher's long-press menu. */
export async function installShortcuts(): Promise<void> {
  if (!isNative()) return;
  try {
    const { AppShortcuts } = await import("@capawesome/capacitor-app-shortcuts");
    await AppShortcuts.set({
      shortcuts: SHORTCUTS.map(({ id, title, description, icon }) => ({ id, title, description, androidIcon: icon })),
    });
  } catch {
    /* a launcher without shortcuts: nothing to add */
  }
}

/** Call `open` with a tapped shortcut's id. Registered once at boot. */
export function onShortcut(open: (id: ShortcutId) => void): void {
  if (!isNative()) return;
  void import("@capawesome/capacitor-app-shortcuts").then(({ AppShortcuts }) =>
    AppShortcuts.addListener("click", ({ shortcutId }) => {
      if (SHORTCUTS.some((s) => s.id === shortcutId)) open(shortcutId as ShortcutId);
    }),
  );
}
